import React from "react";
import { Outlet, useLocation, Link, useParams } from "react-router-dom";
import { Card } from "primereact/card";
import "../../../../components/entities/entities.scss";
import "../../../../components/settings/settings.scss";
import "./user-profile.scss";
import useUserAccess from "~/Pages/UserAccess/useUserAccess";
import Layout from "~/Layout";
import { useGetTenantsId } from "~/api/generated/api";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Skeleton } from "primereact/skeleton";

const UserProfile = () => {
  const { id, userId } = useParams();
  const location = useLocation();
  const activeTab = location.pathname.split("/").pop();
  const { states, handleSelection, handleDiscardUpdate } =
    useUserAccess(userId);

  const { data: tenantResponse, isLoading: isTenantLoading } = useGetTenantsId(
    id!,
  );
  const tenant = tenantResponse?.data?.data;

  const getBreadcrumbLabel = () => {
    if (isTenantLoading)
      return <Skeleton width="200px" height="20px" className="mr-1" />;
    const countryName = tenant?.country ? getName(tenant.country) : "";
    const countryFlag = tenant?.country ? (
      <ReactCountryFlag
        countryCode={tenant.country}
        svg
        style={{ width: "16px", height: "16px", marginRight: "4px" }}
      />
    ) : null;

    return (
      <Link to={`/tenants/${id}`} className="link__style flex">
        <span>
          {tenant?.tenant_name}
          {countryName && (
            <span style={{ marginLeft: "8px" }}>
              ({countryFlag}
              {countryName})
            </span>
          )}
        </span>
      </Link>
    );
  };
  return (
    <Layout
      crumbs={[
        {
          label: (
            <Link to="/tenants" className="link__style flex">
              {"Tenants"}
            </Link>
          ),
        },
        {
          label: getBreadcrumbLabel(),
        },
        {
          label: (
            <Link to={`/tenants/${id}/users`} className="link__style flex">
              {" "}
              {"Assigned Users"}{" "}
            </Link>
          ),
          id: "assigned-user",
        },
        {
          label: states.loadingData ? (
            <Skeleton width="200px" height="20px" className="mr-1" />
          ) : (
            `${states.workosuser?.first_name} ${states.workosuser?.last_name} `
          ),
        },
      ]}
    >
      <div className="grid grid-nogutter">
        <div className="col-12 Entities-container">
          <div className="grid">
            <div className="col-3">
              <Card className="card-style p-0">
                <div className="flex flex-column">
                  <Link
                    to={`/tenants/${id}/users/${userId}/user-info`}
                    className={`sidebar-align ${activeTab === "user-info" ? "active-entity" : "menu-hover"}`}
                  >
                    <div className="flex align-items-center">
                      <p className="sidebar-menu">User Information</p>
                    </div>
                    <span className="pi pi-angle-right icon-color"></span>
                  </Link>
                  <Link
                    to={`/tenants/${id}/users/${userId}/user-service-access`}
                    className={`sidebar-align ${activeTab === "user-service-access" ? "active-entity" : "menu-hover"}`}
                  >
                    <div className="flex align-items-center">
                      <p className="sidebar-menu">Entities & Services</p>
                    </div>
                    <span className="pi pi-angle-right icon-color"></span>
                  </Link>
                </div>
              </Card>
            </div>
            <div className="col-9">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserProfile;
